/**
 * Website-scoped JWT support for the webeditor API (websites/auth_scope.py).
 * This app hardcodes the website slug (no env overrides).
 */

import { PUBLIC_WEBSITE_SLUG } from "@/utils/publicApiConfig";

export const WEBSITE_SLUG_HEADER = 'X-Website-Slug';

export function getWebsiteSlug(): string {
  return PUBLIC_WEBSITE_SLUG;
}

export function applyWebsiteScopeHeaders(
  headers: Record<string, string>
): Record<string, string> {
  headers[WEBSITE_SLUG_HEADER] = getWebsiteSlug();
  return headers;
}
